import React, { useEffect, useState } from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import { Box, Stack } from '@mui/material';
import RegisterWithoutDeposit from './RegisterWithoutDeposit';
import MessageFirstDeposit from './MessageFirstDeposit';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';
import { API_CASINO } from '../../../../../api/casino';
import useNumberParams from '../../../../../hooks/useNumberParams';
import useToast from '../../../../../hooks/useToast';
import LoaderContainer from '../../../../../components/material-ui/loader_container/LoaderContainer';
import useBootstrapSize from '../../../../../hooks/useBootstrapSize';

export default function PlayersTgNotify() {
  const casinoId = useNumberParams('casinoId');
  const { successToast } = useToast();
  const [defaultLang, setDefaultLang] = useState('en');
  const [selectHour, setSelectHour] = useState(0);
  const [textLang, setTextLang] = useState({});

  const [defaultDepLang, setDefaultDepLang] = useState('en');
  const [enabledMesDep, setEnabledMesDep] = useState();
  const [texDeptLang, setTexDeptLang] = useState({});
  const [loader, setLoader] = useState(false);
  const { isLessTablet } = useBootstrapSize();

  function transformTranslations(obj) {
    const langList = {};
    let lang = 'en';

    for (const [key, value] of Object.entries(obj)) {
      if (value && typeof value === 'object' && 'text' in value) {
        langList[key] = value.text;
        if (value.useDefault) lang = key;
      }
    }

    return { langList, lang };
  }

  useEffect(() => {
    if (!casinoId) return;
    setLoader(true);
    API_CASINO.tgNotify.players
      .get({ casinoId })
      .then((e) => {
        const data = e.data.data || {};
        const { afterRegNoDeposit, afterFirstDeposit } = data;
        if (afterFirstDeposit) {
          const { lang, langList } = transformTranslations(afterFirstDeposit.langList);
          setEnabledMesDep(afterFirstDeposit.enabled);
          setTexDeptLang(langList);
          setDefaultDepLang(lang);
        }
        if (afterRegNoDeposit) {
          const { lang, langList } = transformTranslations(afterRegNoDeposit.langList);

          setSelectHour(afterRegNoDeposit.sendAfterHour);
          setTextLang(langList);
          setDefaultLang(lang);
        }
      })
      .catch(console.error)
      .finally(() => setLoader(false));
  }, [casinoId]);

  const onSaveClick = () => {
    const data = {};

    const regNoLangList = {};
    for (let lang in textLang) {
      const text = textLang[lang];
      regNoLangList[lang] = {
        text,
        useDefault: lang == defaultLang
      };
    }

    data.afterRegNoDeposit = {
      sendAfterHour: selectHour,
      langList: regNoLangList
    };

    const regDepLangList = {};
    for (let lang in texDeptLang) {
      const text = texDeptLang[lang];
      regDepLangList[lang] = {
        text,
        useDefault: lang == defaultDepLang
      };
    }

    data.afterFirstDeposit = {
      enabled: enabledMesDep,
      langList: regDepLangList
    };

    console.log('data', data);

    API_CASINO.tgNotify.players
      .set({ casinoId, data })
      .then(() => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  return (
    <CasinoContainer title={'Notifications for players on Telegram'}>
      <LoaderContainer loader={loader}>
        <Stack
          gap={5}
          sx={isLessTablet ? undefined : { maxHeight: 'calc(100svh - 265px)', overflow: 'auto' }}>
          <RegisterWithoutDeposit
            textLang={textLang}
            selectHour={selectHour}
            defaultLang={defaultLang}
            setTextLang={setTextLang}
            setSelectHour={setSelectHour}
            setDefaultLang={setDefaultLang}
          />
          <MessageFirstDeposit
            texDeptLang={texDeptLang}
            enabledMesDep={enabledMesDep}
            defaultLang={defaultDepLang}
            setTexDeptLang={setTexDeptLang}
            setEnabledMesDep={setEnabledMesDep}
            setDefaultLang={setDefaultDepLang}
          />
        </Stack>
        <Box pt={1}>
          <CasinoBtnSave onClick={onSaveClick} />
        </Box>
      </LoaderContainer>
    </CasinoContainer>
  );
}
